import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[iccDocumentDetailContent]'
})
export class DocumentDetailContentDirective {

    constructor(public templateRef: TemplateRef<unknown>) {}

}
